import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu\"><defs><style type=\"text/css\"></style></defs><path d=\"M109.714286 292.571429h804.571428c21.942857 0 36.571429-21.942857 36.571429-43.885715 0-14.628571-14.628571-29.257143-36.571429-29.257143h-804.571428c-21.942857 0-36.571429 14.628571-36.571429 36.571429 0 14.628571 14.628571 36.571429 36.571429 36.571429zM914.285714 512h-804.571428c-21.942857 0-36.571429 14.628571-36.571429 36.571429 0 14.628571 14.628571 36.571429 36.571429 36.571428h804.571428c21.942857 0 36.571429-21.942857 36.571429-43.885714 0-14.628571-14.628571-29.257143-36.571429-29.257143zM914.285714 804.571429h-804.571428c-21.942857 0-36.571429 14.628571-36.571429 36.571428s14.628571 36.571429 36.571429 36.571429h804.571428c21.942857 0 36.571429-21.942857 36.571429-36.571429 0-21.942857-14.628571-36.571429-36.571429-36.571428z\" fill=\"\" p-id=\"1893\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu.svg
// module id = dH9r
// module chunks = 31